export default "__VITE_ASSET__8EKpV_yW__"